<template>
	<div>
		<header class="page-title">
			<h2>Editorial</h2>
			<div class="ml-auto">
				<a @click="saveEditorial" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>

		<div class="grid--nav-horizontal">
			<nav class="nav-horizontal">
				<ul>
					<li :class="[activeTabName === tab.name ? 'active ' + tab.name : tab.name]" v-for="tab in tabs">
						<a @click.prevent="setActiveTabName(tab.name)">{{ tab.displayName }}</a>
					</li>
				</ul>
			</nav>
			<div class="nav-horizontal-contents">
				<div class="card">
					<header class="card-header">
						<h4 class="card-title">General</h4>
					</header>
					<div class="card-body">
						<div class="flex box">
							<div class="six">
								<div class="flex center mb-1">
									<input id="is_author" type="checkbox"
										   v-model="userEditorials[activeTabName].isAuthor"
										   :disabled="userEditorials[activeTabName].authorOnArticles">
									<label for="is_author">Author</label>
									<p class="input-error" v-if="errors.errors[errorAuthor]">{{ errors.errors[errorAuthor] }}</p>
								</div>
								<div class="flex center">
									<input id="is_reviewer" type="checkbox" v-model="userEditorials[activeTabName].isReviewer">
									<label for="is_reviewer">Reviewer</label>
								</div>
							</div>
							<div class="six">
								<div class="form-group mb-0">
									<label for="author-url-slug">Author URL Slug<sup class="text-danger">*</sup></label>
									<input id="author-url-slug" type="text" v-model="userEditorials[activeTabName].url">
									<p class="input-error" v-if="errors.errors[errorUrl]">{{ errors.errors[errorUrl] }}</p>
								</div>
							</div>
							<div v-if="userEditorials[activeTabName].authorOnArticles">
								<p>If author is no longer needed select other author and all his/her articles will be overwritten!</p>
								<div class="six">
									<label for="author">Other Authors</label>
									<select id="author" v-model="selectedAuthorId">
										<option value="">Please select an Author</option>
										<option v-for="author in userEditorials[activeTabName].authors" :value="author.id">{{ author.name }}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card mb-0">
					<header class="card-header">
						<h4 class="card-title">Bios</h4>
					</header>
					<div class="card-body">
						<div class="form-group">
							<label for="job-title">Job Title<sup class="text-danger">*</sup></label>
							<input id="job-title" type="text" v-model="userEditorials[activeTabName].title">
							<p class="input-error" v-if="errors.errors[errorTitle]">{{ errors.errors[errorTitle] }}</p>
						</div>
						<div class="form-group">
							<label for="short-bio">Short Bio<sup class="text-danger">*</sup></label>
							<editor
									id="short-bio"
									:api-key="tinyMCEApiKey"
									:init="tinyMCEConfig"
									v-model="userEditorials[activeTabName].shortBio"
							/>
							<p class="input-error" v-if="errors.errors[errorShortBio]">{{ errors.errors[errorShortBio] }}</p>
						</div>
						<div class="form-group">
							<label for="long-bio">Long Bio<sup class="text-danger">*</sup></label>
							<editor
									id="long-bio"
									:api-key="tinyMCEApiKey"
									:init="tinyMCEConfig"
									v-model="userEditorials[activeTabName].longBio"
							/>
							<p class="input-error" v-if="errors.errors[errorLongBio]">{{ errors.errors[errorLongBio] }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Errors from '../../Utils/Errors.js'
	import Slug from '../../Utils/Slug'

	export default {
		props: {
			dataUserEditorials: {
				type: Object
			},
			dataUserId: {
				type: Number
			}
		},
		data() {
			return {
				userEditorials: this.dataUserEditorials,
				userId: this.dataUserId,
				authors: this.dataUserEditorials.authors,
				selectedAuthorId: this.dataSelectedAuthorId ? this.dataSelectedAuthorId : '',

				tabs: [],
				activeTabName: null,

				errors: new Errors(),
				slug: new Slug(),

				tinyMCEApiKey: this.$tinyMCEApiKey,
				tinyMCEConfig: this.$tinyMCEConfig
			}
		},
		created() {
			let vm = this;
			for (let i = 0; i < vm.$availableSites.length; i++) {
				this.tabs.push({
					displayName: vm.$availableSites[i].name,
					name: vm.$availableSites[i].slug
				});
			}

			this.activeTabName = this.tabs[0].name;
		},
		mounted() {
			this.createEditorShortBio();
			this.createEditorLongBio();
		},
		methods: {
			setActiveTabName: function (name) {
				this.activeTabName = name;
			},
			saveEditorial: function () {
				let vm = this;

				let editorialObject = {};

				for (let i = 0; i < vm.$availableSites.length; i++) {
					vm.userEditorials[vm.$availableSites[i].slug].url = vm.userEditorials[vm.$availableSites[i].slug].url ? vm.slug.refreshSlug(vm.userEditorials[vm.$availableSites[i].slug].url) : null;
					editorialObject[vm.$availableSites[i].slug] = {
						is_author: vm.userEditorials[vm.$availableSites[i].slug].isAuthor,
						is_reviewer: vm.userEditorials[vm.$availableSites[i].slug].isReviewer,
						long_bio: vm.userEditorials[vm.$availableSites[i].slug].longBio,
						short_bio: vm.userEditorials[vm.$availableSites[i].slug].shortBio,
						url: vm.userEditorials[vm.$availableSites[i].slug].url,
						title: vm.userEditorials[vm.$availableSites[i].slug].title,
					};
				}

				if (!vm.selectedAuthorId === false) {
					editorialObject['switch_user'] = {new_author_id: vm.selectedAuthorId};
				} // if

				axios.post('/api/users/' + vm.userId + '/editorial/', editorialObject)
					.then(response => {
						if (response.data.success) {
							if (!vm.selectedAuthorId === false) {
								vm.userEditorials[vm.activeTabName].authorOnArticles = false;
							} // if
							vm.$toastr.success('Editorial data saved successfully', 'Success');
						} else {
							vm.$toastr.error(response.data.failed, 'Error');
						} // if
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						vm.$toastr.error('Editorial data save failed.', 'Error');
					});
			}
		},
		computed: {
			errorUrl: function () {
				return this.activeTabName + '_url';
			},
			errorTitle: function () {
				return this.activeTabName + '_title';
			},
			errorShortBio: function () {
				return this.activeTabName + '_short_bio';
			},
			errorLongBio: function () {
				return this.activeTabName + '_long_bio';
			},
			errorAuthor: function () {
				return this.activeTabName + '_is_author';
			}
		}
	}
</script>

<style scoped>

</style>
